export default "__VITE_ASSET__CtFQsT7F__"